import { InvoiceStatus } from '../../../enums/invoiceStatus'

interface GetInvoicesTablePaidDateOptions {
  displayStatus?: InvoiceStatus
  isCreditNote: boolean
  paidDate?: string | null
}

export const getInvoicesTablePaidDate = (params: GetInvoicesTablePaidDateOptions): string | null => {
  const { displayStatus, isCreditNote, paidDate } = params

  // The stored paid date outlives the status (unpaid again) and credit notes carry their issue date.
  // So only fill it for a non-credit-note whose displayed status is Paid.
  return !isCreditNote && displayStatus === InvoiceStatus.Paid ? (paidDate ?? null) : null
}
